module.exports = __webpack_public_path__ + "r-v3/img/openai.60709abf.svg";